import React from 'react';
import './UsersTable.css';
import { CurrentUserContext } from "../../../contexts/CurrentUserContext.js";
import { ModalEdit, Settings, ModalWindow, Castom, } from '../'
import { ModalContainer, RadioPeriod } from '../../atoms'
import { Tabs } from '../../molecules'
import { SimpleCalendar } from '../../organisms'
import {useFormValidation} from '../../../utils/Validator'
import { subscriptions, mealsArray } from '../../../constants/constants';
import { useSelector , useDispatch} from 'react-redux'
import {editVisor, deleteUsers, editUserAcces, changeSubsVisor, getUserTransaction, deleteUserBonus, editUserBonus, getUserSubs, changeSubStatus} from '../../../store/api.js'

export function UsersTable(props) {
  const user = props.user 
  const {recipes, sts} = useSelector(state => state.recipes)
  const { bonus, statusBonus, transaction , subsHistory} = useSelector(state => state.payment)
  const { plans } = useSelector(state => state.plans)
 // const { bonus, statusBonus, transaction } = useSelector(state => state.payment)
  const { currentUser, rate, statusUser } = useSelector(state => state.currentUser)
  const dispatch= useDispatch()
  const [showChangeModal, setShowChangeModal] = React.useState(false);
  const [rates, setRates] = React.useState([]); 
  const { userActiv } = useSelector(state => state.users)
  const { lib } = useSelector(state => state.lib)
  const [showModalSubs, setShowModalSubs] = React.useState(false); 
  const [showRenewModal, setShowRenewModal] = React.useState(false);
  const [newRates, setNewRates] = React.useState(currentUser.rates) 
  const { 
    values, 
    handleChange,
  } = useFormValidation({
    finance: user.finance && user.finance.summ, 
    bonus: user.bonus && user.bonus.summ, 
    dateAcces: user.dateAcces && user.dateAcces, 
    subscriptions: user.subscriptions && user.subscriptions.title
  });
  const [acces, setAcces] = React.useState(user.acces)
  const [showModal, setShowModal] = React.useState(false)
  const [showModalBonus, setShowModalBonus] = React.useState(false)
  const [type, setType] = React.useState()
  const [name, setName] = React.useState()
  const [types, setTypes] = React.useState([])
  const [powerMode, setPowerMode] = React.useState([])
  const [period, setPeriod] = React.useState('everyday')
  const [weekday, setWeekday] = React.useState([])
  const [ingredientsData, setIngredientsData] = React.useState([])
  const [kitchenware, setKitchenware] = React.useState([])
  const [showModalSetting, setShowModalSetting] = React.useState(false)
  const [selectedSubscription, setSelectedSubscription] = React.useState({})
  const [admin, setAdmin] = React.useState(user.admin);
  const [bonuses, setBonuses] = React.useState(0) 
  const [supervisor, setSupervisor] = React.useState(user.supervisor) 
  const dateAcces = new Date(user.dateAcces).toLocaleDateString()
  const createDate = new Date(user.createdAt).toLocaleDateString()
  const today = new Date()
  let subscription = subscriptions.find(i=> i.title=== values.subscriptions) 
  const userPlans = plans && plans.filter(f=> f.owner === user._id) 
  const lastLogin = user.lastLogin.length> 0 && new Date(user.lastLogin[user.lastLogin.length-1]).toLocaleDateString()
  let countRecipe = recipes.filter(r=> r.owner === user._id)
  const [userLater, setUserLater] =React.useState({})
  const userRate = user.subscription
  const [selectedRateId, setSelectedRateId] = React.useState('')
  const [isOpenPay, setIsOpenPay] = React.useState(false);
  const [isOpenBonus, setIsOpenBonus] = React.useState(false);
  const d = new Date(rate.endDate);  
  const day = String(d.getDate()).padStart(2, '0'); // Получаем день и добавляем ноль перед числом, если нужно
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Получаем месяц и добавляем ноль, так как months начинаются с 0
  const year = d.getFullYear()  
  const formattedDate = `${day}.${month}.${year}`; 
  const [choiceDate, setChoiceDate] = React.useState([]) 
  //Заполнение данных из базы при загрузке страницы
React.useEffect(() => {
  const newtype = [...lib.typeFoods]
    newtype.map(i=> {
      let arr = user.option[0].typeOfDiet.find(k => k._id === i._id);
      if (arr) {
          let updatedObj = {
            _id: i._id,
            nameRu: i.nameRu ,
            nameEn: i.nameEn,
            desc: i.desc, 
            boolean: arr.boolean,
          }; 
          newtype[newtype.indexOf(i)] = updatedObj
        }
      })
 // const newtype= user.settings.typeOfDiet.some(i=> i.nameEn === 'lactoVegan')
 
  setSelectedRateId(user.subscription ? user.subscription.title : '')
  setIngredientsData(user.option.length> 0 ? user.option[0].stopProducts : [])
  setWeekday(user.option.length> 0 ? user.option[0].period : [])
  setTypes(newtype)
  setPeriod(user.option.length> 0 ? user.option[0].periodAn : '')
  setPowerMode(mealsArray) 
  setKitchenware(user.option[0].kitchenware ? user.option[0].kitchenware : lib.kitchenware)
  const availableSubscriptions = lib.rates
  
   setSelectedSubscription(availableSubscriptions[0]) 
  setRates(availableSubscriptions);

}, [user, lib]);

React.useEffect(() => {
  const userLate = userActiv
    .filter(i => i.userID === user._id)
    .sort((a, b) => new Date(b.time) - new Date(a.time))[0];
    if(userLate !== undefined) {
      setUserLater(userLate)
    }    
}, [userActiv, user]);

//Добавление типов питания в массив
const handleCheckBox = (item) => {
  setTypes(() => types.map((c) => c.nameEn === item.nameEn ? item : c));
};

const handleCheckBoxKitchenware = (item) => {
  setKitchenware(() => kitchenware.map((c) => c.nameEn === item.nameEn ? item : c));
};

const handleCheckBoxWeekday = (item) => {
  if(item.nameEn === 'everyday') {
    setWeekday(() => weekday.map((c) => ({
      ...c,
      boolean: item.boolean
    })))
  } else {
    setWeekday(() => weekday.map((c) => c.nameEn === item.nameEn ? item : c))
  }
};

const handleCheckBoxPeriod = (e) => { 
  setPeriod(e.target.value) 
};
 
//Обработка Чекбоксов режима питания
const handleCheckBoxMeals = (item) => {
  setPowerMode(() => powerMode.map((c) => c.nameEn === item.nameEn ? item : c)) 
};

  //Меняем права модератора в системе
  function handlerUserVisor () {
    setSupervisor(!supervisor)
 /*   props.onVisorUser({
      supervisor: !supervisor,
      id: user._id,
    })*/
    dispatch(editVisor({
      supervisor: !supervisor,
      id: user._id,
      current: currentUser.supervisor,
    })) 
  }

  //Добавляем права Админа
  function handleAdminUser () {
    setAdmin(!admin)
    props.onAdminUser({
      user,
      admin: !admin,
    })
  }

  //Добавляем права Админа
  function handleAccesUser () {
    setAcces(!acces)
    props.onAccesUser({
      acces: !acces,
      id: user._id,
    })
  }

   const handleClose = () => {
    setShowChangeModal(false) 
    setShowModalSetting(false) 
    setIsOpenPay(false)
    setIsOpenBonus(false) 
    setShowModal(false)
    setShowModalSetting(false)
    setBonuses(false)
    setShowModalSubs(false)
    setShowModalBonus(false)
   }
  //Удаляем пользователя
  function handleDeleteUser () {
    props.handleDeleteModal(user ) 
    // dispatch(deleteUsers({id: user._id, current: currentUser.supervisor}))
   }

 

  //Изменяем данные доступа у пользователя
  function onChangeInput (data, name) {
    
    setShowModal(true)
    setType(data)
    setName(name)
  }
 
  function handleDateRange(data) {  
    setChoiceDate(data)
  } 

  const toggleModal = () => { 
    setTimeout(() => { 
      setShowChangeModal(false)  
      setShowModalSetting(false)
      setIsOpenPay(false)
      setIsOpenBonus(false)
      setBonuses(false)
      setShowModalSubs(false)
      setShowModalBonus(false)
    }, 300); // Должно совпадать с duration анимации
  
};

//Отправка данных на сервер
  function handleSubmit (e) {
    e.preventDefault();
    let editUser= {
      acces: acces,
      rates: newRates,
      bonus: { 
        summ: values.bonus, 
        recipeActive: user.bonus.recipeActive, 
        sumTraffick: user.bonus.sumTraffick, 
        recipeInActive: user.bonus.recipeInActive},
      dateAcces: values.dateAcces,
      finance: {
        summ: values.finance, 
        receiptTraffic:  user.finance.receiptTraffic, 
        writeDownsTraffic: user.finance.writeDownsTraffic,
        settings: user.option[0],
      },
      settings: user.settings,
      id: user._id
    } 
    dispatch(editUserAcces({supervisor: currentUser.supervisor, ...editUser})) 
    setShowModal(false)
    setShowModalSetting(false)
  } 
  function handleOpenSetting() {
    setShowModalSetting(true)
  }


const handleSubBonus = (e) => {
  e.preventDefault(); 
  dispatch(editUserBonus({amount: bonuses, id: user._id}))
}
 
const handleChangeBonus = (e) => { 
   setBonuses(e.target.value)
}
function handleSubmitSetting(e) {
    e.preventDefault();
    let editUser= {
      acces: acces,
      subscriptions: subscription,
      bonus: { 
        summ: values.bonus, 
        recipeActive: user.bonus.recipeActive, 
        sumTraffick: user.bonus.sumTraffick, 
        recipeInActive: user.bonus.recipeInActive},
      dateAcces: values.dateAcces,
      finance: {
        summ: values.finance, 
        receiptTraffic:  user.finance.receiptTraffic, 
        writeDownsTraffic: user.finance.writeDownsTraffic, 
      },
      settings: {
        sumFamily: user.option[0].sumFamily ? user.option[0].sumFamily : 1,
        cookingTime: user.option[0].cookingTime,
        stopProducts: user.option[0].stopProducts,
        period: user.option[0].period,
        periodAn: user.option[0].periodAn,
        powerMode,
        typeOfDiet: types,
        kitchenware, 
      },
      
      id: user._id
    }
    props.onEditUserData(editUser)
    setShowModalSetting(false)
  }
  
 
  const handleChanges = (event) => {
    
    const selectedId = event.target.value;
    setSelectedRateId(selectedId)
    
    // Обновляем массив подписок
    const updatedRates = newRates.map(rate => ({
        ...rate,
        active: rate.title === selectedId // Устанавливаем active только на выбранный элемент
    }));

    setNewRates(updatedRates); 
   
}; 
  
  // Обработчик продления подписки
  const handleRenewSubscription = (isActive, priceSale, period, bonus) => { 
    setShowChangeModal(false); 
    if(priceSale === 0) {
      dispatch(changeSubsVisor({ priceSale, period, userId:user._id, newSubs: rate.rateId}))
    }
  };

////////////////////////////////////////////// //Смена подписки с учетом оставшихся дней
  const handleSubscriptionChange = (isActive, priceSale, period, bonus) => {  
    setShowChangeModal(false);
    // Здесь должен быть вызов API для сохранения изменений  
     dispatch(changeSubsVisor({date: choiceDate[0], newSubs: selectedSubscription._id, userId:user._id,}))
 
  };

  const handleChangeSub= (sub) => {
    setSelectedSubscription(sub)
  }

  const toggleOpenHistoryPay = () => {
    dispatch(getUserTransaction())
    setIsOpenPay(true)
  }

  
  const toggleOpenHistoryBonus = () => {
    setIsOpenBonus(true)
  }
  const onChangeBonus = () => {
    setShowModalBonus(true)
  }

  const handleDeleteBonus = (id) => {
    dispatch(deleteUserBonus({userId: user._id, transactionId: id}))
  }

  const toggleOpenHistorySubs = (id) => {
    dispatch(getUserSubs({userId: user._id}))
    setShowModalSubs(true)
  }

  const handlechangeSubStatus = (id) => {
    
    dispatch(changeSubStatus({userId: user._id, subsId: id }))
     
  }

  return (
    <div className='table__tr_user' >
      <div className='table__td_user'>{user.name} {user.email} {user._id}</div>
      <div className='table__td_user width10'>
        <p className='user__item table__acces'><span className='user__item_meaning'>{!userRate ? 'НЕТ' : userRate.title}</span>
        <div className='font12Norm item__link widt70 ta-r' onClick={toggleOpenHistorySubs}> История подписок </div> 
        {currentUser.supervisor && 
          <button className='buttonGreen buttonGreenMini' onClick={() => setShowChangeModal(true)}>Изменить</button>
        }

      </p>
        </div>
      <div className='table__td_user table__acces width10'>
      <div className='user__item table__acces user__item__acces'> <span className={`user__item_meaning ${user.supervisor ? 'user__yes' : ''}`}>Сурвизор</span>
        {currentUser.supervisor && 
          <button className='buttonGreen buttonGreenMini' onClick={handlerUserVisor} >Изменить</button>
        }
      </div>
      <div className='user__item table__acces user__item__acces'><span className={`user__item_meaning ${user.acces ? 'user__yes' : ''}`}>Доступ</span>
        {currentUser.supervisor && 
          <button className='buttonGreen buttonGreenMini' onClick={handleAccesUser}>Изменить</button>
        }
      </div>
      <div className='user__item table__acces user__item__acces'><span className={`user__item_meaning ${user.admin ? 'user__yes' : ''}`}>Админ</span>
        {currentUser.supervisor && 
          <button className='buttonGreen buttonGreenMini' onClick={handleAdminUser}>Изменить</button>
        }
      </div>
        </div>
   
      <div className='table__td_user table__acces'>
      <p className='user__item'><span className='user__item_meaning'>Создан: {userRate ? FormattedDate(user.createdAt): 0} </span></p>
      <p className='user__item'><span className='user__item_meaning'> Активна до: {userRate ?FormattedDate(userRate.endDate):0}</span></p>
 
      
        </div>
     
      <div className=' table__td_buttons user__acces'>
 
      <div className='user__item table__acces'> <p className='user__item_bonus'>{user?.bonusAccount?.balance || 0} Б</p>
        {currentUser.supervisor && 
        <>
          <button className='item__button' onClick={onChangeBonus}>Изменить</button> 
          <div className='font12Norm item__link widt70 ta-r' onClick={toggleOpenHistoryPay}> История списаний / начислений </div>  
          { user?.bonusAccount?.balance &&
            <div className='font12Norm item__link ml-a'  onClick={toggleOpenHistoryBonus}> История начислений бонусов</div>  
          }
        
          </>
        }
      </div>
        </div>
        <div> 
        <p className='user__item'> <span>
        Рецептов: {user?.recipeCount || 0} </span>
        <span>Планов: {user?.planCount || 0} </span>
      </p>
        </div>
        <div className='user__item_button'> 
        <button className='gg-edit' onClick={handleOpenSetting}/>
        <button className='gg-delete' onClick={handleDeleteUser}/> 
        </div>
     {/*<ModalContainer 
      isOpen={showModalSetting}
      onClose={handleClose}
      title='settings'
    > 
       <Settings type='plans' onClose={handleClose} user={user} /> 
    </ModalContainer>*/}
   
    {/* Модальное окно смены подписки */}
  {showChangeModal && userRate &&
  <ModalWindow onClose={handleClose} title='user' head=''  toggleModal={toggleModal}> 
    <EditRate 
      setShowChangeModal={setShowChangeModal} 
      handleSubscriptionChange={handleSubscriptionChange} 
      setSelectedSubscription={setSelectedSubscription}
      selectedSubscription={selectedSubscription}   
      rates={rates}  
      subscription={userRate}
      handleChangeSub={handleChangeSub}
      type='change ' 
      handleDateRange={handleDateRange}
      choiceDate={choiceDate} 
    />
  </ModalWindow> 
  }
  
  {showModalSetting && 
    <ModalWindow onClose={handleClose} title='castom' head=''  toggleModal={toggleModal}>  
     <Tabs  user={user}/>
     </ModalWindow> 
  }
  {isOpenPay &&
    <ModalWindow onClose={handleClose} title='history-pay' head=''  toggleModal={toggleModal} >
      <HistoryPay formattedDate={formattedDate} transaction={transaction}/>
    </ModalWindow>
  }
 
  {/*Модальное окно истории бонусов*/}
  {isOpenBonus &&
    <ModalWindow  onClose={handleClose} title='history-bonus' head=''  toggleModal={toggleModal} >
      <HistoryBonus  bonusTransactions={user?.bonusAccount?.bonusTransactions} handleDeleteBonus={handleDeleteBonus} />
    </ModalWindow> 
  }
  { showModalBonus &&
    <ModalWindow  onClose={handleClose} title='history-bonus' head=''  toggleModal={toggleModal} >
    <BonusEdit value={bonuses} onSubmit={handleSubBonus} onChange={handleChangeBonus}/>
  </ModalWindow>   
  }

  { showModalSubs &&
    <ModalWindow  onClose={handleClose} title='history-bonus' head=''  toggleModal={toggleModal} >
    <HistorySubs subsHistory={subsHistory}  handlechangeSubStatus={handlechangeSubStatus} />
  </ModalWindow>   
  }

    <ModalEdit 
      isOpen={showModal} 
      onClose={handleClose}
      onChange={handleChange}
      handleChanges={handleChanges}
      onSubmit={handleSubmit}
      type={type}  
      name={name}
      rate={newRates}
      selectedRateId={selectedRateId}
      value={values}
    />

</div>
  )
   
}


const IngData = (props) => {
  const {ingredients} = useSelector(state => state.ingredients)
  const ingredient = ingredients.find(f => f._id === props.item); 
  return (
    <>
    { ingredient !== undefined ?
      <p className='ingredient__measure_text'>{ingredient.name} </p> 
      :"ингредиент не найден"
    }
    </>
  
  )
}


const EditRate = ({ 
  handleSubscriptionChange, 
  selectedSubscription, 
  rates, 
  availableBonus,
  handleRenewSubscription,
  type, 
  handleChangeSub,  
  handleDateRange,
  choiceDate,
  subscription,

}) => {
 
  const { currentUser, rate, statusUser } = useSelector(state => state.currentUser)
  const price = type !== 'change' ? selectedSubscription.price : rate.price
  const [isActive, setIsActive] = React.useState(false);
  const [sale, setSale] = React.useState(1)
  const { lib, statusLib } = useSelector(state => state.lib)  
  const [promoText, setPromoText] = React.useState('')
  const [errorCode, setErrorCode] = React.useState('')
  const [promo, setPromo] = React.useState('')
  const [period, setPeriod] = React.useState('month')
  const [priceSale, setPriceSale] = React.useState(0)
  const [priceBase, setPriceBase] = React.useState(0)
  const [bonus, setBonus] = React.useState(0) 
  
  
  React.useEffect(()=> {
    if(statusLib === 'resolved' && promoText) {
      const searchDate =  lib.promocode.find(p=> p.title ===promoText && new Date() <new Date(p.dateAcces))
      if(searchDate) {
        setSale(1-searchDate.sale/100)
        setErrorCode('')
      } else {
        setSale(1)
        setErrorCode('Введен неверный промокод или он недействителен!')
      }
    }
  },[lib, promoText])

  React.useEffect(()=> {
   
    setPriceSale(countPriceSale(price, period, sale, isActive))
    setPriceBase(countPriceBase(price, period))
  },[isActive, sale, period, price])

  function handleChangePromo(e) {
    setPromo(e.target.value) 
  }


  function hadleSubmitPromocode(text) { 
    setPromoText(text)  
  }

  const handleToggle = (e) => {
    const newValue = e.target.checked;
    setIsActive(newValue); 
  };
 
  function countPriceSale(price, period, sale, isActive) {
    const salePrice = period === 'threemonth' ? Math.ceil(price*0.8*3*sale) : period === 'sixmonths' ? Math.ceil(price*0.7*6*sale) : period === 'year' ? Math.ceil(price*0.55*12*sale) : Math.ceil(price*sale)
    const bonus =  Math.min(availableBonus, salePrice)
    setBonus(Math.min(availableBonus, salePrice))
    return isActive ? Math.ceil(salePrice - bonus) : salePrice
  } 

  function countPriceBase(price, period,) {
    return period === 'threemonth' ? Math.ceil(price*3) : period === 'sixmonths' ? Math.ceil(price*6) : period === 'year' ? Math.ceil(price*12) : price
  }

  function handleChangePeriod(e) { 
    setPeriod(e.target.value) 
  }
   
  const toggleSubscriptionChange = () => {  
    handleSubscriptionChange(isActive, priceSale, period, bonus)
  }
  return (
    <div className="df-c profile_modal g10 ai-c"> 
    <h3 className='colorGrey font14EB'>Сменить тарифный план</h3>
    <h3 className='colorGrey font14Norm item__search'>Текущий тариф: <span className='greyUp'> {subscription.title}</span></h3>
    <div className="subscription__block"> 
      {rates.map(sub => (
        <div 
          key={sub._id} 
          className={`subscription-option item__link ${selectedSubscription._id === sub._id ? 'subs__selected' : ''}`}
          onClick={()=> handleChangeSub(sub)}
        >
          <h4 className='greyUp font16Norm'>{sub.title} </h4> 
        </div>
      ))}
    </div>
    <SimpleCalendar 
          meals={[]} 
          userMenu={[]} 
          isOpen= 'true'
          dateDay={choiceDate}   
          type='subs'  
          onDayRange={handleDateRange}/> 
    <button className='change-button' onClick={toggleSubscriptionChange}>Сменить тариф</button>
 
    </div> 
  )

}

const HistoryPay = ({transaction, }) => {

  return (
    <div className='df-c js-b profile_modal '>
    <h3 className="font18EB colorGrey">История платежей</h3>
    <ul className='df-c js-b g20'>
      {transaction?.length > 0 ?
      transaction.map(item=> (
        <li key={item._id} item={item} className='df-r ai-c g20'>
          <p className={`m-size ${item.type === 'out'? 'gg-debit' : 'gg-credit'}`}></p>
          <p className='font14Norm colorGrey'>{FormattedDate(item.createdAt)}</p>
          <p  className='font14Norm colorGrey'>{item.description} {item.sourceName}</p>
        <p  className='font14Norm colorGrey ml-a'> {item.amount} ₽</p>
        </li>
      )) 
      : 
      <div className='recipe_none'>
        <p className='gg-no-dish'></p> 
        <p className=' font20Nprm '>Ничего не найдено</p> 
      </div> 
      }
    </ul>
    </div>
  )
}

const HistorySubs = ({subsHistory, handlechangeSubStatus}) => {

  return (
    <div className='df-c js-b profile_modal '>
    <h3 className="font18EB colorGrey">История Подписок</h3>
    <ul className='df-c js-b g20'>
      {subsHistory?.length > 0 ?
      subsHistory.map(item=> (
        <li key={item._id} item={item} className='df-r ai-c g20'>
          <p className={`m-size ${item.type === 'out'? 'gg-debit' : 'gg-credit'}`}></p>
          <p className='font14Norm colorGrey'>{FormattedDate(item.startDate)} до <p className='font14Norm colorGrey'>{FormattedDate(item.endDate)}</p></p>
          <p  className='font14Norm colorGrey'>{item.title} {item.sourceName}</p>
          <p  className='font14Norm colorGrey'>{item.status} {item.sourceName}</p>
        <p  className='font14Norm colorGrey ml-a'> {item.paidAmount} ₽</p>
        <p  className='font14Norm colorGrey'>{item.paymentMethod} {item.sourceName}</p>
        <p  className='font14Norm colorGrey'>{item.period} {item.sourceName}</p>
        {item.status === 'active' && 
          <button className='buttonGreen' onClick={()=> handlechangeSubStatus(item._id)} type="button" aria-label='Добавить'> Добавить в архив</button> 
        }
         
        
        </li>
      )) 
      : 
      <div className='recipe_none'>
        <p className='gg-no-dish'></p> 
        <p className=' font20Nprm '>Ничего не найдено</p> 
      </div> 
      }
    </ul>
    </div>
  )
}

const HistoryBonus = ({bonusTransactions, handleDeleteBonus}) => {
  return (
    <div className='df-c js-b profile_modal '>
    <h3 className="font18EB colorGrey">История платежей</h3>
    <ul className='df-c js-b g20'>
      {bonusTransactions?.length > 0 ?
      bonusTransactions.map(item=> (
        <li key={item._id} item={item} className='df-r ai-c g20'>
          <p className={`m-size ${item.type === 'out'? 'gg-debit' : 'gg-credit'}`}></p>
          <p className='font14Norm colorGrey'>{FormattedDate(item.createdAt)}</p>
          <p  className='font14Norm colorGrey'>{item.description} {item.sourceName}</p>
          <p  className='font14Norm colorGrey ml-a'> {item.amount} Б</p>
          <p  className='font14Norm m-size gg-delete' onClick={()=> handleDeleteBonus(item._id)}/>
        </li>
      )) 
      : 
      <div className='recipe_none'>
        <p className='gg-no-dish'></p> 
        <p className=' font20Nprm '>Ничего не найдено</p> 
      </div> 
      }
    </ul>
    </div>
  )
}

const Sale = (props) => {
  return (
    <form className='sale__account'>
      <RadioPeriod onChange={props.onChange} period={props.period} type='account'/>  
      
     </form>
    )
  }

  const FormattedDate = (dateString) => { 
    if (!dateString) return null; 
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return null;
  
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
  
    return (
      `${day}.${month}.${year}`
    )
  };

  function BonusEdit (props) {
 
    return (
       
          <form className="form__info" onSubmit={props.onSubmit}> 
            
            <label className='add-recipe__label' htmlFor={props.name} >
               <input 
                autoComplete="off" 
                type='number'
                onChange={props.onChange} 
                value={props.value} 
                placeholder="Введите данные" 
                className="form__item form__item_type_email" 
                name={props.name} 
                id={props.name} 
                required
              />
            </label>
            <button className={`form__button ${props.submitDisabled ? ('form__button_disabled') : 'section__link'}`} type="submit" aria-label='Сохранить'>Сохранить</button> 
          </form>
       
    )
  }